/*
 * Links for people in the song credits (data/songs.js `credits`). A name
 * written here becomes a link wherever it appears in any release's credits;
 * names without a link stay plain text. Spell the name exactly as in songs.js.
 */
export const PEOPLE = {
  "Sam Ari": "https://www.facebook.com/beepbopban",
  "True Sound Asia": "https://www.facebook.com/truesoundlabel",
  "Bao Le": "https://www.instagram.com/_baole__",
  "Tyler Le": "https://www.instagram.com/dela.thanh/",
  "Bryan Shortell": "https://www.instagram.com/shordeli/",
};
